// extracted by mini-css-extract-plugin
export default {"menu":"menu--XoYz+ChQAk"};